module.exports = __webpack_public_path__ + "img/saint-vicent-and-the-grenadines.f84fa036.svg";